// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import releaseCoverageEntity from './entities/release-coverage.json';
import releaseCoverageMenu from '../pages/release-coverage/menu.json';
import releaseCoverageFullForm from '../pages/release-coverage/forms/full.json';
import releaseCoverageContextForm from '../pages/release-coverage/forms/context.json';
import releaseCoverageMiniForm from '../pages/release-coverage/forms/mini.json';
import releaseCoverageLookupForm from '../pages/release-coverage/forms/lookup.json';
import releaseCoverageTableView from '../pages/release-coverage/views/table.json';
import releaseCoverageCardsView from '../pages/release-coverage/views/cards.json';
import releaseCoverageCalendarView from '../pages/release-coverage/views/calendar.json';
import releaseCoverageDashboardView from '../pages/release-coverage/views/dashboard.json';

/** Тип запису «Висвітлення» зі сторінками пакета: меню, форми та подання з pages/release-coverage/. */
export const releaseCoverageDefinition: IRecordTypeDefinition = {
  ...releaseCoverageEntity,
  views: assembleViewSet({
      table: releaseCoverageTableView,
      cards: releaseCoverageCardsView,
      calendar: releaseCoverageCalendarView,
      dashboard: releaseCoverageDashboardView,
  }),
  form: releaseCoverageFullForm,
  forms: { full: releaseCoverageFullForm, context: releaseCoverageContextForm, mini: releaseCoverageMiniForm, lookup: releaseCoverageLookupForm },
  menu: releaseCoverageMenu,
} as IRecordTypeDefinition;
